import React from 'react';
import ContractFullDTO from 'features/contracts/dtos/ContractFullDTO';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import ContractDetailLayoutPage from './ContractDetailLayoutPage';
import RolesChecker from 'features/customer/components/RolesChecker';
import { getContractDetailRootRoute } from 'features/shared/helpers/routeHelper';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { useLocation } from 'react-router-dom';
import ReservedCapacityLocationState from 'features/contracts/models/ReservedCapacityLocationState';
import { useTranslation } from 'react-i18next';
import ReservedCapacityElectricityMonthlyFormSection from 'features/requirements/sections/requirementFormTypes/reservedCapacityElectricity/ReservedCapacityElectricityMonthlyFormSection';
import { isEnabledCustomForm } from 'features/requirements/helpers/requirementTypeHelper';

type Props = {
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
}

const ChangeReservedCapacityElectricityMonthly = ({ contract, contractEnergy }: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation(["contracts\\contracts"]).t;

  // router
  const { state: locationState  } = useLocation<ReservedCapacityLocationState>();

  // render
  return (
    <ContractDetailLayoutPage
      contract={contract}
      contractEnergy={contractEnergy}
      links={[
        { text: tModules("reservedCapacityPage.title"), to: getContractDetailRootRoute(contract.contractId!, "reserved-capacity") },
        { text: tModules("changeReservedCapacityElectricityMonthly.title") }
      ]}
    >
      <RenderWrapper isVisible={() => isEnabledCustomForm("ZMENAKAPACITYELEKTRINAMESICNI")}>
        <RolesChecker enabledRoles="Contributor">
          <ReservedCapacityElectricityMonthlyFormSection
            selectedContractId={contract.contractId}
            selectedYear={locationState ? locationState.selectedYear : undefined}
            sendButtonTitle={tLabels("changeReservedCapacityPage.changeCapacity")}
            useOutsideOfRequirements
          />
        </RolesChecker>
      </RenderWrapper>
    </ContractDetailLayoutPage>
  )
}

export default ChangeReservedCapacityElectricityMonthly;